import css from 'styled-jsx/css';

const ClockStyles = css`
  .clock-container {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
  }
`;

export { ClockStyles };
